exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-4ef884ae]{margin-bottom:0}.default-set-icon[data-v-4ef884ae]{cursor:pointer;width:15px;display:inline-block}.checkbox-wrapper[data-v-4ef884ae]{max-width:calc(100% - 20px)}ion-icon.none.yellow[data-v-4ef884ae]{color:#ffc107}", ""]);

// exports
